import { defaultTo, equals, filterL, go, head, some } from "fxjs/es";
export class SingleStickerEditorWorkingLayer {
  constructor({ layer_el, Node, SVGGraphicsElement }) {
    this._SVGGraphicsElement = SVGGraphicsElement;
    this._Node = Node;
    this._layer_el = layer_el;
  }
  getGraphicsEls() {
    return new Set(
      filterL((node) => node instanceof this._SVGGraphicsElement)(
        this._layer_el.childNodes.values()
      )
    );
  }
  convertToGraphicsEl(a) {
    if (!(a instanceof this._Node)) {
      return null;
    }
    return go(
      this._layer_el.childNodes.values(),
      filterL((node) => node instanceof this._SVGGraphicsElement),
      filterL((el) => el.contains(a)),
      head,
      defaultTo(null)
    );
  }
  getIsChildGraphicsEl(el) {
    if (!(el instanceof this._SVGGraphicsElement)) {
      return false;
    }
    return go(
      this._layer_el.childNodes.values(),
      filterL((node) => node instanceof this._SVGGraphicsElement),
      some(equals(el))
    );
  }
  getNextGraphicsEl(el) {
    if (!this.getIsChildGraphicsEl(el)) {
      return null;
    }
    return go(
      el.nextElementSibling,
      function* (cur_el) {
        while (cur_el != null) {
          yield cur_el;
          cur_el = cur_el?.nextElementSibling;
        }
      },
      filterL((el) => this.getIsChildGraphicsEl(el)),
      head,
      defaultTo(null)
    );
  }
  getPrevGraphicsEl(el) {
    if (!this.getIsChildGraphicsEl(el)) {
      return null;
    }
    return go(
      el.previousElementSibling,
      function* (cur_el) {
        while (cur_el != null) {
          yield cur_el;
          cur_el = cur_el?.previousElementSibling;
        }
      },
      filterL((el) => this.getIsChildGraphicsEl(el)),
      head,
      defaultTo(null)
    );
  }
}
